import { render, staticRenderFns } from "./journal-short.vue?vue&type=template&id=73417247"
import script from "./journal-short.vue?vue&type=script&lang=js"
export * from "./journal-short.vue?vue&type=script&lang=js"
import style0 from "./journal-short.vue?vue&type=style&index=0&id=73417247&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports